import * as Yup from 'yup'
import { translate } from '../Translations/translate'

const ChefReferralSchema = (lang) => Yup.object().shape({
  description: Yup.string().min(2).required(),
})

export default ChefReferralSchema